export enum TransferTokensFlowStates {
    TUTORIAL, //When the user first access this flow
    REQUIRED_CONFIRMATION, // When the user clicks start operation
    FROM_EMAIL, // When the user access from email link
    CONFIRMED_OPERATION // When the user clicks on CONFIRM
}